import { render, staticRenderFns } from "./IconsWithTooltips.vue?vue&type=template&id=7a590560"
import script from "./IconsWithTooltips.vue?vue&type=script&lang=ts"
export * from "./IconsWithTooltips.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports